export const statisticsEn = {
  "Versement": "Payment",
  "Comptabilité": "Comptability",
  "Pourcentage": "Percentage",
  "soins": "Care",
  "Mode de paiement": "Payment Method",
  "Total Restante": "Total Remaining",
  "Statistiques Financières": "Financial Statistics",
}